// src/components/PendingResourceDetail.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useTranslatedText } from '../i18n/useTranslatedText.js';
import './PendingResourceDetail.css'; // Use a CSS file based on pendingeventdetail.css with resource-specific classnames

const PendingResourceDetail = () => {
  const { resourceId } = useParams();
  const navigate = useNavigate();
  const [resource, setResource] = useState(null);
  const [loading, setLoading] = useState(true);
  const loadingText = useTranslatedText('Yükleniyor...');
  const notFoundText = useTranslatedText('Kaynak bulunamadı');
  const authorLabel = useTranslatedText('Yazar:');
  const publishDateLabel = useTranslatedText('Yayın Tarihi:');
  const confirmText = useTranslatedText('Onayla');
  const denyText = useTranslatedText('Reddet');
  const confirmedAlertText = useTranslatedText('Kaynak onaylandı!');
  const deniedAlertText = useTranslatedText('Kaynak reddedildi ve silindi.');

  useEffect(() => {
    const fetchResource = async () => {
      try {
        const resourceDoc = await getDoc(doc(db, 'resources', resourceId));
        if (resourceDoc.exists()) {
          setResource({ id: resourceDoc.id, ...resourceDoc.data() });
        }
      } catch (error) {
        console.error("Error fetching resource:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchResource();
  }, [resourceId]);

  const handleConfirm = async () => {
    try {
      await updateDoc(doc(db, 'resources', resourceId), { status: 'confirmed' });
      alert(confirmedAlertText);
      navigate('/içerik-onayla');
    } catch (error) {
      console.error("Error confirming resource:", error);
    }
  };

  const handleDeny = async () => {
    try {
      await deleteDoc(doc(db, 'resources', resourceId));
      alert(deniedAlertText);
      navigate('/içerik-onayla');
    } catch (error) {
      console.error("Error denying resource:", error);
    }
  };

  if (loading) {
    return <div>{loadingText}</div>;
  }
  
  if (!resource) {
    return <div>{notFoundText}</div>;
  }

  return (
    <div className="pending-resource-detail">
      <h2 className="detail-title">{resource.title}</h2>
      <div className="detail-thumbnail">
        <img src={resource.thumbnailUrl} alt={resource.title} />
      </div>
      <p className="detail-meta">
        <strong>{authorLabel}</strong> {resource.author}
      </p>
      <p className="detail-meta">
      <strong>{publishDateLabel}</strong> {resource.publishDate}
      </p>
      <div className="detail-description">
        <p>{resource.description}</p>
      </div>
      <div className="confirm-actions">
        <button className="approve-button" onClick={handleConfirm}>{confirmText}</button>
        <button className="disapprove-button" onClick={handleDeny}>{denyText}</button>
      </div>
    </div>
  );
};

export default PendingResourceDetail;
